import { ViewProps } from './interactive-ebook.constants';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentStartCover } from '../shared/component-parts';
import InteractiveExpandModal from '../interactive/interactive-expand-modal';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';

const InteractiveEbookView = (
  props: ViewProps & { onStimulusOpen?: () => void; disableModal?: boolean }
) => {
  const {
    type,
    properties,
    stimulusResourceProperties,
    onStimulusOpen,
    disableModal,
  } = props;

  const { isVisible, closeModal, openModal } = useSimpleModalState();

  const { style, setContainerElement, elementDimensions } =
    useContainerDimensions({
      aspectRatio: 16 / 9,
    });

  return stimulusResourceProperties?.link ? (
    <>
      <ComponentAspectRatio dimensions={properties.dimensionData}>
        <ComponentAbsoluteWrapper ref={setContainerElement}>
          <ComponentStartCover
            backgroundImage={
              stimulusResourceProperties?.xlCoverImageUrls?.length
                ? getClosestImageUrl({
                    imageUrls: stimulusResourceProperties.xlCoverImageUrls,
                    containerSize: elementDimensions?.width
                      ? Math.max(
                          elementDimensions.width,
                          elementDimensions.height
                        )
                      : window.innerWidth,
                    quality: ImageDisplayQuality.High,
                  })
                : stimulusResourceProperties?.coverImage?.original
            }
            buttonLabel="Start"
            resourceName={stimulusResourceProperties.resourceName}
            type={props.type}
            style={style}
            onClick={
              !disableModal
                ? () => {
                    openModal?.();
                    onStimulusOpen?.();
                  }
                : undefined
            }
            data-selector="btn-start"
          />
        </ComponentAbsoluteWrapper>
      </ComponentAspectRatio>

      {isVisible && (
        <InteractiveExpandModal
          stimulusLink={stimulusResourceProperties.link}
          type={type}
          onClose={closeModal}
          guidedReadThroughs={{
            resources: stimulusResourceProperties.guidedReadThroughs || [],
            stimulusResourceId: properties?.stimulusId || undefined,
          }}
        />
      )}
    </>
  ) : null;
};

export default InteractiveEbookView;
